/* eslint-disable */

import React from 'react';

function PolicyWeb() {
  return (
    <div className='policy-list'>
      <div className='policy-item'>
        ข้อตกลงการสมัครใช้บริการของบริษัท มียามียา จำกัด
        การสมัครใช้บริการนั้นถือว่าผู้สมัครได้อ่านและทำความเข้าใจเงื่อนไขการใช้บริการเรียบร้อยแล้ว
        และผู้สมัครใช้บริการยอมรับเงื่อนไขทุกประการ โดยมีผลผูกพันผู้ใช้บริการตามกฎหมาย
      </div>
      <div className='policy-item text-primary mt-1'>1. คำจำกัดความ</div>
      <div className='policy-item'>
        <span className='text-black'>“ข้อตกลง”</span> หมายถึง
        เงื่อนไขการใช้บริการข้อผูกพันระหว่างผู้ให้บริการและผู้ให้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-black'>“คู่สัญญา”</span> หมายถึง บริษัท มียามียา จำกัด
        และผู้สมัครใช้บริการที่ผ่านการอนุมัติจากบริษัทผ่านทาง มียา.com หรือ meya.co.th
      </div>
      <div className='policy-item'>
        <span className='text-black'>“ค่าบริการ”</span> หมายถึง
        ค่าธรรมเนียมบริการที่เรียกเก็บจากการให้บริการจากผู้ซื้อ และ/หรือ ผู้ขาย
      </div>
      <div className='policy-item'>
        <span className='text-black'>“สมาชิก”</span> หมายถึง ผู้สมัครใช้บริการที่ผ่านการอนุมัติ
        ผ่านระบบของบริษัท โดยสมาชิกสามารถเป็นทั้งผู้ซื้อ และ ผู้ขาย
      </div>
      <div className='policy-item'>
        <span className='text-black'>“ข้อมูล”</span> หมายความถึง ข้อมูลใด ๆ
        ที่ผู้ใช้บริการหรือผู้ที่ได้รับมอบอำนาจจากผู้ใช้บริการให้ทำการแทนได้ให้ไว้แก่ทางเว็บไซต์
      </div>
      <div className='policy-item'>
        <span className='text-black'>“สิทธิในทางทรัพย์สินทางปัญญา”</span> หมายความถึง สิทธิบัตร,
        เครื่องหมายการค้า, เครื่องหมายบริการ, ลิขสิทธิ์, สิทธิโดยธรรม, สิทธิในแบบผลิตภัณฑ์
        ไม่ว่าจะได้จดทะเบียนไว้แล้วหรือไม่ก็ตาม
      </div>
      <div className='policy-item text-primary mt-1'>2. การให้บริการ</div>
      <div className='policy-item'>
        <span className='text-primary'>2.1</span>{' '}
        การให้บริการของเราจะสอดคล้องตามที่ปรากฏบนเว็บไซต์ของเรา
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.2</span>{' '}
        เราสามารถเปลี่ยนแปลงบริการของเราเมื่อเราพิจารณาว่าจำเป็นตามความต้องการและสถานการณ์
        โดยการเปลี่ยนแปลงจะมีผลทันทีเมื่อมีการปรับปรุงบนเว็บไซต์
        และเราจะแจ้งให้คุณทราบผ่านทางอีเมลหรือเว็บไซต์
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.3</span> เมื่อคุณใช้บริการของเราผ่านเว็บไซต์
        คุณได้รับสิทธิ์ในการใช้งานซอฟต์แวร์ตามแพคเกจที่คุณเลือก และสิทธิ์นี้ไม่สามารถโอนได้
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.4</span>{' '}
        คุณสามารถมอบหมายให้บุคคลอื่นเข้าใช้ระบบเพื่อจัดการบัญชี
        และคุณต้องรับผิดชอบต่อการกระทำของบุคคลนั้น ๆ ในระบบ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.5</span> คุณมีสิทธิ์ในการเปลี่ยนแปลง จำกัด
        หรือยกเลิกการใช้งานของผู้ใช้ในระบบตามที่คุณพิจารณาเหมาะสม
        และเราจะปฏิบัติตามคำร้องขอหรือคำสั่งของคุณในการแก้ไขข้อพิพาท
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.6</span>{' '}
        เราสงวนสิทธิในการไม่ปฏิบัติตามคำร้องขอหรือคำสั่งจากบุคคลภายนอกที่ไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากคุณ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>2.7</span>{' '}
        เราให้บริการเพียงในฐานะเครื่องมือการจัดการร้านขายยาของคุณเท่านั้น หากมีปัญหาเกี่ยวกับบัญชี
        คุณต้องปรึกษานักบัญชีผู้มีความรู้เชี่ยวชาญโดยตรง
      </div>
      <div className='policy-item text-primary mt-1'>
        3. การสมัครใช้บริการ การต่อสัญญา และการเลิกสัญญา
      </div>
      <div className='policy-item'>
        <span className='text-primary'>3.1</span> การสมัครใช้บริการ
      </div>
      <div className='policy-item'>• สมัครบริการผ่านเว็บไซต์ meya.co.th หรือ มียา.com</div>
      <div className='policy-item'>• ข้อมูลต้องเป็นความจริง และถูกต้องตามหลักฐานทางราชการ</div>
      <div className='policy-item'>
        • ข้อมูลเท็จจะทำให้สูญเสียสิทธิประโยชน์และบริษัทสามารถยกเลิกการให้บริการได้
      </div>
      <div className='policy-item'>• ห้ามแก้ไขข้อมูลสำคัญเช่น ไอดี, บัตรประชาชน ฯ</div>
      <div className='policy-item'>• ความเป็นส่วนตัวต้องเก็บรักษาเป็นความลับ</div>
      <div className='policy-item'>
        • ข้อมูลของผู้ใช้ถือเป็นทรัพย์สินของบริษัท ห้ามนำไปใช้เพื่อการค้าหรือโอนสิทธิ์
      </div>
      <div className='policy-item'>
        • บริการที่ใช้ได้ไม่ควรละเมิดสิทธิของผู้อื่น หรือกระทำผิดกฎหมาย
      </div>
      <div className='policy-item'>• ผู้ใช้ต้องตรวจสอบข้อมูลและปฏิบัติตามกฎระเบียบของบริษัท</div>
      <div className='policy-item'>
        <span className='text-primary'>3.2</span> การเลิกสัญญา
      </div>
      <div className='policy-item'>
        <span className='text-primary'>3.2.1</span> สิทธิในการเลิกสัญญาของผู้ใช้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>3.2.1.1</span> กรณีเลิกสัญญาประเภทที่ไม่มีค่าบริการ:
        สามารถส่งคำขอเลิกใช้บริการที่ contact@mediception.net
      </div>
      <div className='policy-item'>
        <span className='text-primary'>3.2.1.2</span> กรณีเลิกสัญญาประเภทมีค่าธรรมเนียม:
        สามารถส่งคำขอเลิกใช้บริการที่ contact@mediception.net
        ได้ทุกเวลาก่อนสิ้นสุดระยะเวลาการใช้บริการ
        การยื่นคำขอนี้จะทำให้สัญญาเลิกในวันสุดท้ายของปีการใช้บริการ โดยในกรณีที่ต้องการเลิกทันที
        (ปิด Account ก่อนสิ้นสุดระยะเวลาการใช้บริการ)
        จะไม่มีการคืนเงินค่าธรรมเนียมที่ชำระไว้ไม่ว่ากรณีใด ๆ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>3.2.2</span> สิทธิในการเลิกสัญญาของ meya.co.th
        <div className='policy-item'>
          <span className='text-primary'>3.2.2.1</span> มียา.com หรือ meya.co.th
          มีสิทธิบอกเลิกสัญญาได้โดยไม่จำกัดเวลา หลังจากที่มียา.com หรือ meya.co.th
          ได้ทำการบอกเลิกสัญญาแล้ว การเลิกสัญญาจะมีผลในวันสุดท้ายของระยะเวลาการใช้บริการในปีนั้น
        </div>
        <div className='policy-item text-primary mt-1'>4. หน้าที่ของผู้ใช้บริการ</div>
        <div className='policy-item'>
          <span className='text-primary'>4.1</span> การชำระค่าธรรมเนียม
        </div>
        ท่านมีหน้าที่ชำระค่าธรรมเนียมหรือตามอัตราที่กำหนด โดย มียา.com หรือ meya.co.th
        จะเป็นผู้กำหนดค่าธรรมเนียมบริการและแจ้งให้ทราบล่วงหน้า ก่อนอย่างน้อย 30 วัน
        ตามอัตราที่กำหนดไว้ จนกว่าจะมีการเลิกสัญญา
        ในกรณีที่ผู้ใช้บริการไม่ชำระค่าธรรมเนียมหรือชำระล่าช้าทางบริษัทขอสงวนสิทธิในการระงับการใช้บริการของท่านชั่วคราวจนกว่าจะมีการชำระราคาโดยสิ้นเชิง
        ทั้งนี้ มียา.com หรือ meya.co.th ไม่มีความรับผิดใด ๆ
        ในความเสียหายที่เกิดจากการระงับการใช้บริการด้วยเหตุดังกล่าว
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.2</span> การให้ข้อมูล
        ท่านมีหน้าที่ให้ข้อมูลที่ถูกต้องเป็นจริงทุกประการแก่ มียา.com หรือ meya.co.th
        ในกรณีที่มีการเปลี่ยนชื่อ, ชื่อบริษัท, ชื่อทางการค้า, ตัวแทน,
        ที่อยู่หรือข้อมูลอื่นในการติดต่อ ท่านจะต้องแจ้งการเปลี่ยนแปลงดังกล่าวให้ มียา.com หรือ
        meya.co.th ทราบเป็นลายลักษณ์อักษรโดยทันที ตามวิธีการแจ้งข้อมูลที่ มียา.com หรือ meya.co.th
        กำหนด โดย มียา.com หรือ meya.co.th
        อาจขอให้ท่านส่งเอกสารเพื่อยืนยันการเปลี่ยนแปลงข้อมูลดังกล่าว
        และท่านยอมรับว่าจะปฏิบัติตามคำร้องขอดังกล่าวของ meya.co.th
      </div>

      <div className='policy-item'>
        <span className='text-primary'>4.3</span> ข้อห้ามในการใช้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.3.1</span> ท่านมีสิทธิใช้บริการของ มียา.com หรือ meya.co.th
        เพื่อจัดการร้านขายยาของท่านโดยสุจริต และชอบด้วยกฎหมายเท่านั้น
        ทั้งนี้ท่านจะต้องไม่ใช้บริการของ มียา.com หรือ meya.co.th เพื่อสนับสนุน
        หรือใช้ในทางที่เกี่ยวข้องกับการหรือกิจการใด ๆ อันมีวัตถุประสงค์ต้องห้ามชัดแจ้งตามกฎหมายไทย
        หรือขัดต่อศีลธรรมอันดีของประชาชนชาวไทย หรือที่สร้างความเสื่อมเสีย หรือทำลายความมั่นคง
        ต่อประเทศชาติ ศาสนา และ สถาบันพระมหากษัตริย์ ทั้งนี้ หากมีการตรวจพบการกระทำดังกล่าว มียา.com
        หรือ meya.co.th ขอสงวนสิทธิในการบอกเลิกสัญญาโดยมิต้องแจ้งล่วงหน้าและไม่คืนค่าบริการใด ๆ
        ทั้งสิ้น และ ไม่มีความรับผิดต่อความเสียหายใด ๆ ต่อตัวผู้ฝ่าฝืนหรือบุคคลภายนอก
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.3.2</span> ท่านจะต้องไม่ส่งข้อมูลใด ๆ เข้ามาในระบบของ
        มียา.com หรือ meya.co.th อันเป็นความผิดตาม พ.ร.บ คอมพิวเตอร์ พ.ศ. 2550 มาตรา 14
        ที่บัญญัติไว้ว่า “ผู้ใดกระทำความผิดที่ระบุไว้ดังต่อไปนี้ ต้องระวางโทษจำคุกไม่เกินห้าปี
        หรือปรับไม่เกินหนึ่งแสนบาท หรือทั้งจำทั้งปรับ
      </div>
      <div className='policy-item'>
        (๑) นำเข้าสู่ระบบคอมพิวเตอร์ซึ่งข้อมูลคอมพิวเตอร์ปลอมไม่ว่าทั้งหมดหรือบางส่วน
        หรือข้อมูลคอมพิวเตอร์อันเป็นเท็จโดยประการที่น่าจะเกิดความเสียหายแก่ผู้อื่นหรือ ประชาชน
      </div>
      <div className='policy-item'>
        (๒) นำเข้าสู่ระบบคอมพิวเตอร์ซึ่งข้อมูลคอมพิวเตอร์อันเป็นเท็จ
        โดยประการที่น่าจะเกิดความเสียหายต่อความมั่นคงของประเทศหรือก่อให้เกิดความตื่นตระหนกแก่ประชาชน
      </div>
      <div className='policy-item'>
        (๓) นำเข้าสู่ระบบคอมพิวเตอร์ซึ่งข้อมูลคอมพิวเตอร์ใด ๆ
        อันเป็นความผิดเกี่ยวกับความมั่นคงแห่งราชอาณาจักรหรือความผิดเกี่ยวกับการก่อการร้ายตามประมวลกฎหมายอาญา
      </div>
      <div className='policy-item'>
        (๔) นำเข้าสู่ระบบคอมพิวเตอร์ซึ่งข้อมูลคอมพิวเตอร์ใด ๆ
        ที่มีลักษณะอันลามกและข้อมูลคอมพิวเตอร์นั้นประชาชนทั่วไปอาจเข้าถึงได้
      </div>
      <div className='policy-item'>
        (๕) เผยแพร่หรือส่งต่อซึ่งข้อมูลคอมพิวเตอร์โดยรู้อยู่แล้วว่าเป็นข้อมูลคอมพิวเตอร์ตาม (๑)(๒)
        (๓) หรือ (๔)”
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4</span> หน้าที่ทั่วไปในการใช้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.1</span> ท่านจะต้องเก็บรักษา User name และ Password
        ของท่านไว้ด้วยความระมัดระวังและเป็นความลับ
        โดยท่านจะเป็นฝ่ายรับความเสี่ยงในกรณีที่บุคคลภายนอกใช้รหัสผ่านโดยฉ้อฉลหรือโดยมิได้รับอนุญาต
        มียา.com หรือ meya.co.th จะถือว่าการใช้รหัสผ่านที่ลงทะเบียนใด ๆ
        เป็นการกระทำของท่านในฐานะคู่สัญญาที่ถือรหัสผ่านดังกล่าว ในกรณีที่มีการใช้ User name และ
        Password ของท่านโดยบุคคลภายนอกที่ปราศจากอำนาจ ท่านมีหน้าที่ที่จะต้องแจ้งเหตุดังกล่าวให้
        มียา.com หรือ meya.co.th ทราบโดยทันที
        เพื่อที่ทางเราจะได้ใช้มาตราการเพื่อทำการยับยั้งและแก้ไขปัญหาดังกล่าวได้อย่างทันท่วงที
        ทังนี้มาตรการดังกล่าวมีขึ้นเพื่อให้ความช่วยเหลือแก่ท่านเท่านั้น มียา.com หรือ meya.co.th
        ไม่มีความรับผิดใด ๆ ต่อท่านหรือผู้อื่นในความบกพร่องหรือผลใด ๆ ของการใช้มาตรการเช่นว่า
        เมื่อท่านสมัครใช้บริการ ถือว่าท่านให้ความยินยอมล่วงหน้าแก่ มียา.com หรือ meya.co.th
        ในการดำเนินมาตราการดังกล่าว
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.2</span> ท่านจะต้องไม่พยายามหรือกระทำการใด ๆ
        ที่เป็นอันตรายต่อความปลอดภัยของระบบคอมพิวเตอร์หรือระบบเน็ตเวิร์คของ มียา.com หรือ meya.co.th
        และของบุคคลภายนอกที่ มียา.com หรือ meya.co.th ได้ใช้ประกอบการให้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.3</span> ท่านจะต้องไม่พยายามหรือกระทำการใด ๆ
        เพื่อเข้าถึงส่วนใด ๆ ของเว็บไซต์โดยปราศจากอำนาจในการกระทำเช่นว่า
        เว้นแต่ท่านได้รับอนุญาตโดยชัดแจ้งให้ทำได้
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.4</span> ท่านจะต้องไม่ส่งหรือป้อนข้อมูล หรือเอกสารใด ๆ
        เข้ามาในเว็บไซด์โดยประการที่อาจทำให้เกิดความเสียหายแก่อุปกรณ์ ฮาร์ดแวร์ หรือ ซอฟท์แวร์ ของ
        มียา.com หรือ meya.co.th หรือ ของบุคคลภายนอกที่ มียา.com หรือ meya.co.th
        ได้ใช้ประกอบการให้บริการ หรือของสมาชิกท่านอื่น ข้อความนี้ให้รวมถึง
        การส่งหรือป้อนข้อมูลหรือเอกสารใดที่ละเมิดต่อกฎหมาย หรือ ที่ท่านไม่มีสิทธิจะใช้ตามกฎหมาย
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.5</span>{' '}
        ในกรณีที่มีบุคคลอื่นใช้สิทธิเรียกร้องหรือมีข้อเรียกร้องต่อท่าน
        หรือท่านถูกฟ้องร้องดำเนินคดีเกี่ยวกับหรือมีสาเหตุมาจากการใช้บริการของ มียา.com หรือ
        meya.co.th ท่านจะยุติข้อเรียกร้องด้วยค่าใช้จ่ายและความรับผิดชอบของท่านเอง และท่านจะไม่ให้ อ
        มียา.com หรือ meya.co.th เข้าไปเกี่ยวข้องในการยุติข้อเรียกร้องดังกล่าว
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.6</span> ในกรณีที่ มียา.com หรือ meya.co.th
        มีค่าเสียหายหรือค่าใช้จ่ายไม่ว่าโดยตรงหรือโดยอ้อม (รวมทั้งค่าทนายความ)
        เกี่ยวกับหรือมีสาเหตุมาจากการใช้บริการของท่าน
        ท่านยอมรับว่าจะชดใช้ค่าเสียหายหรือค่าใช้จ่ายดังกล่าวให้แก่ มียา.com หรือ meya.co.th
        โดยสิ้นเชิง
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.7</span>{' '}
        หากท่านกำหนดให้ผู้ใช้บริการรายอื่นหรือบุคคลภายนอกเข้ามีส่วนร่วมในการดูแลจัดการบัญชีของท่าน
        บริษัทจะถือว่าการปฏิบัติของบุคคลภายนอกดังกล่าวคือการปฏิบัติของท่าน
        หากการปฏิบัติของบุคคลดังกล่าวก่อให้เกิดความเสียหายหรือการเสียผลประโยชน์แก่ท่าน
        บริษัทจะไม่รับผิดชอบใด ๆ ทั้งสิ้น
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.8</span> ในกรณีที่ท่านประสบปัญหาด้านเทคนิค หรือการใช้งาน
        ท่านมีหน้าที่ในการตรวจสอบ วิเคราะห์และแก้ไขปัญหาในเบื้องต้น หากท่านมีข้อสงสัย
        หรือต้องการความช่วยเหลือเพิ่มเติมประการใด ให้ติดต่อ หน่วยสนับสนุนให้ความช่วยเหลือ (Help
        support) ของ ทาง มียา.com หรือ meya.co.th ตามช่องทางการติดต่อที่แสดงไว้บนหน้าเว็บไซต์
      </div>
      <div className='policy-item'>
        <span className='text-primary'>4.4.9</span> การผิดหน้าที่ใด ๆ ตามที่ระบุไว้ มียา.com หรือ
        meya.co.th มีสิทธิเด็ดขาดในการระงับการให้บริการชั่วคราว
        หรือมีสิทธิบอกเลิกสัญญาโดยไม่ต้องแจ้งให้ทราบล่วงหน้าและไม่ต้องคืนค่าบริการใด ๆ ทั้งสิ้น
      </div>
      <div className='policy-item'>
        6. การรักษาความลับของข้อมูล เราให้ความสำคัญกับการรักษาความลับของข้อมูลของคุณ
        และเราจะไม่เปิดเผยข้อมูลของคุณให้แก่บุคคลภายนอกหรือองค์กรอื่นใดที่อาจทำให้คุณเสียหายหรือละเมิดสิทธิความเป็นส่วนตัวของคุณ
        เราอาจต้องเปิดเผยข้อมูลการใช้ระบบของคุณกับบุคคลอื่น เช่น พันธมิตรทางธุรกิจ
        หรือหน่วยงานรัฐบาล เมื่อเราเชื่อว่าจำเป็นต่อการปฏิบัติตามกฎหมาย
        หรือเพื่อคุ้มครองสิทธิของเราหรือสิทธิของบุคคลภายนอก
        เราจะปฏิบัติตามนโยบายความเป็นส่วนตัวเพื่อเคารพข้อมูลของคุณ
        โปรดอ่านเพิ่มเติมในนโยบายความเป็นส่วนตัวเพื่อข้อมูลเพิ่มเติม
      </div>
      <div className='policy-item text-primary mt-1'>5. ทรัพย์สินทางปัญญา</div>

      <div className='policy-item'>
        <span className='text-primary'>5.1</span> มียา.com หรือ meya.co.th
        เป็นเจ้าของลิขสิทธิ์และทรัพย์สินทางปัญญาในข้อมูล รูปภาพ และรูปแบบการแสดงผลในเว็บไซต์ทั้งหมด
        ห้ามมิให้ทำการคัดลอก ทำซ้ำ สำเนา สำรองไว้ ทำเหมือน ดัดแปลง
        หรือเผยแพร่โดยไม่ได้รับอนุญาตเป็นหนังสือจาก มียา.com หรือ meya.co.th
        ยกเว้นมีการระบุไว้ในข้อตกลงและเงื่อนไขในเว็บไซต์
      </div>

      <div className='policy-item'>
        <span className='text-primary'>5.2</span> ข้อมูลหรือเอกสารอิเลคทรอนิคส์ใน Account
        ของคุณถือเป็นทรัพย์สินของคุณ
        การเข้าถึงข้อมูลหรือเอกสารอิเลคทรอนิคส์จะต้องอยู่ในเงื่อนไขที่คุณได้ชำระค่าบริการรายปีแล้ว
        และอนุญาตให้ มียา.com หรือ meya.co.th ใช้ คัดลอก ส่ง จัดเก็บ
        หรือทำการสำรองข้อมูลเพื่อให้บริการ
      </div>

      <div className='policy-item'>
        <span className='text-primary'>5.3</span>{' '}
        การสำรองข้อมูลและเก็บรักษาข้อมูลของคุณเป็นนโยบายและทางปฏิบัติที่สำคัญ มียา.com หรือ
        meya.co.th มีมาตราการรักษาข้อมูลตามมาตรฐานสากลเพื่อป้องกันการสูญหายหรือเสียหายของข้อมูล
        แต่ไม่สามารถรับประกันได้ว่าข้อมูลจะไม่สูญหายหรือเสียหาย ดังนั้น
        คุณมีหน้าที่สำรองข้อมูลหรือทำการคัดลอกเพื่อความปลอดภัยของข้อมูลของคุณ และมียา.com หรือ
        meya.co.th ไม่รับผิดชอบในกรณีข้อมูลสูญหายหรือเสียหาย
        การรักษาความลับของข้อมูลของคุณเป็นสิ่งสำคัญ มียา.com หรือ meya.co.th
        จะไม่เปิดเผยข้อมูลของคุณให้แก่บุคคลภายนอก
        ยกเว้นเฉพาะกรณีที่ได้รับอนุญาตหรือมีการระบุโดยชัดเจน อีกทั้ง
        ข้อมูลในบัญชีของคุณจะถือเป็นทรัพย์สินของคุณเอง และมียา.com หรือ meya.co.th
        จะใช้ข้อมูลเพื่อให้บริการเท่านั้น ไม่รับผิดชอบในกรณีข้อมูลสูญหายหรือเสียหาย ดังนั้น
        คุณมีหน้าที่สำรองข้อมูลของคุณเองเพื่อความปลอดภัยในการใช้งาน
      </div>

      <div className='policy-item text-primary mt-1'>6. การระงับการให้บริการ</div>
      <div className='policy-item'>
        <span className='text-primary'>6.1</span> มียา.com หรือ meya.co.th
        อาจระงับการให้บริการเป็นการชั่วคราว ด้วยเหตุจำเป็นบางประการ (ตามข้อกำหนดที่ 6.2)
        และในกรณีที่มีการระงับบริการประเภทที่มีค่าบริการ มียา.com หรือ meya.co.th
        ขอสงวนสิทธิในการไม่คืนค่าบริการสำหรับระยะเวลาที่ระงับบริการดังกล่าว และถือว่า มียา.com หรือ
        meya.co.th ไม่มีความรับผิดในการระงับบริการดังกล่าวไม่ว่าประการใด
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2</span>{' '}
        เหตุแห่งการระงับการให้บริการอาจรวมถึงแต่ไม่จำกัดเป็นการเฉพาะ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2.1</span> การบำรุงรักษาอุปกรณ์ที่จำเป็นสำหรับการให้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2.2</span> อุปกรณ์ที่จำเป็นในการให้บริการไม่สามารถใช้งานได้
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2.3</span>{' '}
        เกิดเหตุในด้านการปฏิบัติการหรือด้านเทคนิคซึ่งส่งผลต่อการให้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2.4</span> การขัดข้องของระบบของบุคคลภายนอกที่ มียา.com หรือ
        meya.co.th ใช้ประกอบการให้บริการของระบบ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>6.2.5</span> การเกิดเหตุการณ์ที่เป็นอุปสรรคในการให้บริการ
        ยกตัวอย่างเช่นไฟฟ้าขัดข้อง, ไฟ ไหม้, น้ำท่วม, ภัยธรรมชาติ, ภัยพิบัติต่าง ๆ,
        ความไม่สงบของเหตุการณ์บ้านเมือง, การนัดหยุดงาน หรือ เหตุสุดวิสัยอื่นใด
      </div>
      <div className='policy-item text-primary mt-1'>
        7. การยกเลิกการให้บริการ มียา.com หรือ meya.co.th
        ขอสงวนสิทธิในการยกเลิกการให้บริการทั้งหมดหรือแต่บางส่วน โดยไม่ต้องแจ้งล่วงหน้า
        และไม่มีความรับผิดใด ๆต่อคู่สัญญาและบุคคลภายนอก
      </div>
      <div className='policy-item text-primary mt-1'>8. ข้อจำกัดความรับผิด</div>
      <div className='policy-item'>
        <span className='text-primary'>8.1.</span> มียา.com หรือ meya.co.th
        ไม่สามารถรับประกันได้ว่าบริการของเราจะปราศจากข้อบกพร่องหรือความไม่แน่นอน เช่น ความเสถียร,
        ความเชื่อถือได้, ความแม่นยำ, ความสมบูรณ์, ความเหมาะสมกับวัตถุประสงค์, หรือความปลอดภัย
        เนื่องจากระบบที่เกี่ยวข้องมีความไม่แน่นอนและอาจเกิดการรบกวนหรือเป็นอุปสรรค
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.2.</span> มียา.com หรือ meya.co.th
        ไม่รับผิดชอบต่อความเสียหายที่เกิดขึ้นจากการใช้บริการหรือข้อบกพร่องในการให้บริการ
        เว้นแต่เป็นความเสียหายที่เกิดจากการจงใจหรือความประมาทร้ายแรงของเรา ในกรณีดังกล่าว
        เราจะรับผิดชอบต่อค่าเสียหายที่เกิดขึ้นโดยตรงไม่เกินค่าบริการรายปีที่คุณชำระในปีนั้น
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.3.</span> ความสมบูรณ์ของเงื่อนไขการใช้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.4.</span> หากมีข้อกำหนดหรือข้อความใดในเงื่อนไขการใช้บริการ
        มียา.com หรือ meya.co.th ฉบับ นี้เป็นโมฆะหรือใช้บังคับไม่ได้ตามกฎหมายไทย
        ให้ถือว่าข้อกำหนดหรือข้อความที่ตกเป็นโมฆะหรือใช้บังคับไม่ได้นั้นไม่มีผลกระทบต่อความสมบูรณ์หรือการบังคับใช้ข้อกำหนดอื่นที่เหลือหรือกฎเกณฑ์อื่นที่เกี่ยวข้อง
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.5.</span> การขัดกันของเงื่อนไขการใช้บริการ
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.6.</span>{' '}
        ในกรณีที่มีความแตกต่างระหว่างข้อกำหนดในการใช้บริการ มียา.com หรือ meya.co.th
        ฉบับภาษาไทยและฉบับคำแปล เงื่อนไขการใช้บริการ มียา.com หรือ meya.co.th
        ฉบับภาษาไทยจะมีผลเหนือเงื่อนไขฉบับภาษาอื่น
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.7.</span> กฎหมายที่ใช้บังคับ และเขตอำนาจศาล
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.8.</span> เงื่อนในการใช้บริการ มียา.com หรือ meya.co.th
        ฉบับนี้ อยู่ภายใต้บังคับของกฎหมายไทย
        โดยไม่คำนึงถึงกฎหรือบทบัญญัติว่าด้วยการเลือกกฎหมายหรือการขัดกันของกฎหมาย
        และให้ศาลในราชอาณาจักรไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาชี้ขาดตัดสินข้อพิพาทที่เกิดขึ้นภายใต้เงื่อนไขการใช้บริการฉบับนี้
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.9.</span> มียา.com หรือ meya.co.th
        ขอสงวนสิทธิในการเปลี่ยนแปลงเงื่อนไขการใช้บริการไม่ว่าเวลาใด
      </div>
      <div className='policy-item'>
        <span className='text-primary'>8.10.</span>{' '}
        โดยถือว่าการเปลี่ยนแปลงมีผลทันทีเมื่อทำการแก้ไขบนหน้าเว็บไซต์ ทั้งนี้ มียา.com หรือ
        meya.co.th
        จะดำเนินการอย่างเต็มความสามารถเพื่อแจ้งให้ผู้ใช้บริการทุกท่านทราบถึงการเปลี่ยนแปลงเช่นว่าผ่านช่องทางอีเมล์
        หรือหน้าเว็บไซต์
        โดยถือเป็นหน้าที่ของลูกค้าในการอ่านและทำความเข้าใจเงื่อนไขการบริการล่าสุดที่ปรากฎบนหน้าเว็บไซต์
      </div>
    </div>
  );
}

export default PolicyWeb;
